import { shallowMount, createLocalVue } from '@vue/test-utils';
import XsellProduct from "./XsellProduct";
import { currency } from '../../../../filters';
const localVue = createLocalVue();
localVue.filter('currency', currency);

const xsellMembershipDescription = 'This is xsellMembershipDescription';
const marketingTagLine = 'This is marketingTagLine';
const product_type_display_name = 'This is product_type_display_name';
const short_description = 'This is short_description';
const desc = 'This is desc';

const item = {
  id: 34,
  name: 'Bolzano Brown',
  price: 24,
  sub_price: 22,
  imagery: {
    thumb: {
      url: '/image/url',
      alt_text: 'Image Alt Text'
    }
  },
  xsellMembershipDescription,
  short_description
};

const createWrapper = (item, processing, canAttach) => {
  return shallowMount(XsellProduct, {
    localVue,
    propsData: {
      item,
      processing,
      canAttach
    }
  });
};

describe('XsellProduct', () => {
  describe('UI', () => {
    test('snapshot for product that can be attached to sub', () => {
      let localItem = Object.assign({}, item);
      let wrapper = createWrapper(localItem, false, true);
      expect(wrapper.html()).toMatchSnapshot();
    });

    test('snapshot for product that can NOT be attached to sub', () => {
      let localItem = Object.assign({}, item);
      let wrapper = createWrapper(localItem, false, false);
      expect(wrapper.html()).toMatchSnapshot();
    });

    test('add-to-cart button emit event', () => {
      let localItem = Object.assign({}, item);
      let wrapper = createWrapper(localItem, false, true);

      wrapper.find('button.add-to-cart').trigger('click');
      let emittedEvent = wrapper.emitted('add-product');

      expect(emittedEvent).toBeTruthy();
      //- assert event count
      expect(emittedEvent.length).toBe(1);
      //- assert event payload
      expect(emittedEvent[0][1]).toStrictEqual(item);
      expect(emittedEvent[0][2]).toBe(true);
    });
  });

  describe('computed', () => {
    describe('topLabel', () => {
      test('return xsellMembershipDescription as first choice', () => {
        let localState = {
          item: {
            id: 18,
            xsellMembershipDescription,
            marketingTagLine,
            product_type_display_name
          }
        };

        let res = XsellProduct.computed.topLabel.call(localState);
        expect(res).toBe(xsellMembershipDescription);
      });

      test('return marketingTagLine when xsellMembershipDescription does not exist', () => {
        let localState = {
          item: {
            id: 18,
            marketingTagLine,
            product_type_display_name
          }
        };

        let res = XsellProduct.computed.topLabel.call(localState);
        expect(res).toBe(marketingTagLine);
      });

      test('return product_type_display_name when xsellMembershipDescription and marketingTagLine does not exist', () => {
        let localState = {
          item: {
            id: 18,
            product_type_display_name
          }
        };

        let res = XsellProduct.computed.topLabel.call(localState);
        expect(res).toBe(product_type_display_name);
      });
    });

    describe('productCategory', () => {
      test('return product_type_name as first choice', () => {
        let localState = {
          item: {
            id: 26,
            product_type_name: 'Gloss'
          }
        };

        let res = XsellProduct.computed.productCategory.call(localState);
        expect(res).toEqual('Gloss');
      });

      test('return productTypeName as second choice', () => {
        let localState = {
          item: {
            id: 26,
            productTypeName: 'Gloss'
          }
        };

        let res = XsellProduct.computed.productCategory.call(localState);
        expect(res).toEqual('Gloss');
      });
    });

    describe('description', () => {
      test('return short_description as default', () => {
        let localState = {
          item: {
            id: 18,
            short_description,
            desc
          }
        };

        let res = XsellProduct.computed.description.call(localState);
        expect(res).toBe(short_description);
      });

      test('return descr when short_description does not exist', () => {
        let localState = {
          item: {
            id: 18,
            desc
          }
        };

        let res = XsellProduct.computed.description.call(localState);
        expect(res).toBe(desc);
      });
    });

    describe('buttonText', () => {
      test('text when attachToSub is true', () => {
        let localThis = { attachToSub: true };

        expect(XsellProduct.computed.buttonText.call(localThis)).toBe('Add to Every Order');
      });

      test('text when attachToSub is false', () => {
        let localThis = { attachToSub: false };

        expect(XsellProduct.computed.buttonText.call(localThis)).toBe('Add to Next Order');
      });
    });
  });

  describe('mounted', () => {
    test('set attachToSub to true when canAttach is true', () => {
      let wrapper = createWrapper(item, false, true);
      expect(wrapper.vm.attachToSub).toBe(true);
    });
  });
});
